export default {
  print: 'general.print',
};
